<template>
	<v-dialog max-width="600px" fullscreen hide-overlay v-model="showDialog">
		<div>
			<div class="header" :style="{ backgroundColor: themeInputColor }">
				<v-btn
					fab
					flat
					icon
					class="top-left-align pa-0 ma-0 z-index--2"
					@click="closeModal"
				>
					<v-icon color="#FFF">arrow_back</v-icon> </v-btn
				>Transaction History

				<v-dialog v-model="dialog" width="500">
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							fab
							flat
							icon
							class="top-right-align pa-0 ma-0 z-index--2"
							v-bind="attrs"
							v-on="on"
						>
							<v-icon color="#FFF">download</v-icon>
						</v-btn>
					</template>

					<v-card>
						<v-card-title class="text-h5 grey lighten-2">
							Download Passbook
						</v-card-title>
						<v-menu
							v-model="startDateMenu"
							:close-on-content-click="false"
							:nudge-right="40"
							transition="scale-transition"
							offset-y
							min-width="auto"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
									v-model="startDate"
									label="Select start date"
									prepend-icon="mdi-calendar"
									readonly
									v-bind="attrs"
									v-on="on"
								></v-text-field>
							</template>
							<v-date-picker
								v-model="startDate"
								@input="startDateMenu = false"
								:max="new Date().toISOString().substr(0, 10)"
							></v-date-picker>
						</v-menu>
						<v-menu
							v-model="endDateMenu"
							:close-on-content-click="false"
							:nudge-right="40"
							transition="scale-transition"
							offset-y
							min-width="auto"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
									v-model="endDate"
									label="Select end date"
									prepend-icon="mdi-calendar"
									readonly
									v-bind="attrs"
									v-on="on"
									:error="!isEndDateGreaterThanStartDate"
								></v-text-field>
							</template>
							<v-date-picker
								v-model="endDate"
								@input="endDateMenu = false"
								:max="new Date().toISOString().substr(0, 10)"
							></v-date-picker>
						</v-menu>
						<div
							class="error--text pl-4"
							v-show="!isEndDateGreaterThanStartDate"
						>
							Start date should not be greater than end date
						</div>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn
								color="primary"
								text
								@click="downloadPassbook"
								:disabled="!isEndDateGreaterThanStartDate"
							>
								Download
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
				<v-dialog v-model="revertDialog" persistent max-width="290">
					<v-card style="border-radius: 1em" class="pa-2">
						<v-card-text
							class="grey--text text--darken-3 body-2 font-weight-bold"
						>
							Do you want to revert the transaction. This process
							can't be undone.
						</v-card-text>

						<v-card-actions>
							<v-spacer></v-spacer>

							<v-btn
								color="blue-grey lighten-1"
								flat
								small
								@click="closeRevertDialog"
							>
								Cancel
							</v-btn>

							<v-btn
								color="green darken-1"
								flat
								small
								@click="revertTransaction"
							>
								Revert
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</div>
			<v-card
				min-height="100vh"
				color="#EDF0F7"
				class="bg"
				v-infinite-scroll="() => (data.offset ? loadMoreData(END) : {})"
				infinite-scroll-disabled="loading"
				infinite-scroll-distance="200"
				infinite-scroll-throttle-delay="200"
			>
				<v-switch
					v-model="showCommissionOnly"
					label="Show Commission Entries Only"
					class="ml-2"
					color="#233b5d"
					v-if="isJeet11Distributor"
				/>
				<v-card
					v-for="(item, i) in data.list"
					:key="i"
					class="card-item"
				>
					<div
						class="d-flex justify-space-between"
						@click="show = show === i ? -1 : i"
					>
						<div>
							<div class="title theme-text pb-2">
								{{
									(item.user
										? item.user.teamName
											? item.user.teamName
											: item.user.retailerName
										: item.userId) || "-"
								}}
							</div>
							<div
								class="caption blue-grey--text text--lighten-1"
							>
								{{ item.createdOn }}
							</div>
						</div>
						<div>
							<div
								class="d-flex justify-end title"
								:class="
									item.paymentType === `credit`
										? `light-blue--text text--darken-4`
										: `blue-grey--text text--lighten-1`
								"
							>
								{{
									item.paymentType === "credit"
										? "+ ₹"
										: "- ₹"
								}}{{ item.amount.toLocaleString() }}
							</div>
							<div class="text-right">
								<!-- <v-btn
									v-if="
										item.isReverseAllow &&
											isJeet11Distributor
									"
									color="green darken-1"
									small
									:loading="
										inProgressTxn === item.transactionId
									"
									@click.stop="
										() =>
											openRevertDialog(item.transactionId)
									"
									class="mr-4 white--text"
									>Revert</v-btn
								> -->
								<v-btn icon class="expand-more mt-2">
									<v-icon>{{
										show === i
											? "expand_less"
											: "expand_more"
									}}</v-icon></v-btn
								>
							</div>
						</div>
					</div>
					<v-expand-transition>
						<div v-show="show === i">
							<div class="pt-3 px-1">
								<div class="d-flex justify-space-between">
									<div
										class="pr-4 caption blue-grey--text text--darken-1"
									>
										Mode
									</div>
									<div
										class="align-right caption blue-grey--text text--darken-3"
									>
										{{ item.mode || "-" }}
									</div>
								</div>
								<div
									class="d-flex justify-space-between pt-1"
									v-if="
										item.mode !==
											'distributorContestCommission'
									"
								>
									<div
										class="pr-4 caption blue-grey--text text--darken-1"
									>
										Txn Id
									</div>
									<div
										class="align-right caption blue-grey--text text--darken-3"
									>
										{{ item.transactionId || "-" }}
									</div>
								</div>
								<div class="d-flex justify-space-between pt-1">
									<div
										class="pr-4 caption blue-grey--text text--darken-1"
									>
										Id
									</div>
									<div
										class="align-right caption blue-grey--text text--darken-3"
									>
										{{ item.id || "-" }}
									</div>
								</div>
								<div
									class="d-flex justify-space-between pt-1"
									v-if="
										item.user &&
											Number(item.user.phoneNo) > 0
									"
								>
									<div
										class="pr-4 caption blue-grey--text text--darken-1"
									>
										Phone No
									</div>
									<div
										class="align-right caption blue-grey--text text--darken-3"
									>
										{{ item.user.phoneNo }}
									</div>
								</div>
								<div
									class="d-flex flex-column justify-space-between pt-1 "
									v-if="
										item.mode ===
											'distributorContestCommission'
									"
								>
									<div
										class="d-flex justify-space-between pt-1"
									>
										<div
											class="pr-4 caption blue-grey--text text--darken-1"
										>
											Participation Money
										</div>
										<div
											class="align-right caption blue--text text--darken-4"
										>
											{{
												_get(
													item,
													"commissionDetails.participationMoney",
													"-"
												)
											}}
										</div>
									</div>
									<div
										class="d-flex justify-space-between pt-1"
									>
										<div
											class="pr-4 caption blue-grey--text text--darken-1"
										>
											Stake Percentage
										</div>
										<div
											class="align-right caption blue--text text--darken-4"
										>
											{{
												Number(
													_get(
														item,
														"commissionDetails.stakePercentage",
														0
													)
												).toFixed(2)
											}}%
										</div>
									</div>
									<div
										class="d-flex justify-space-between pt-1"
										v-if="_get(item, 'user.userId')"
									>
										<div
											class="pr-4 body-2 blue-grey--text text--darken-1"
										>
											User
										</div>
										<div
											class="align-right body-2 blue--text text--darken-4"
											style="text-decoration: underline"
											@click.stop="
												() =>
													showUserHistory(
														item.user.userId
													)
											"
										>
											{{
												_get(
													item,
													"user.teamName",
													item.user.userId
												)
											}}
										</div>
									</div>
								</div>
							</div>
						</div>
					</v-expand-transition>
				</v-card>
			</v-card>
		</div>
	</v-dialog>
</template>
<script>
import { TOP, END } from "@/store/config";
import infiniteScroll from "vue-infinite-scroll";
import { BASE_URL } from "../../config";
import ApiService from "@/store/api-service";
import { mapState } from "vuex";
import {
	FETCH_JEET11_PARTNER_WALLET_DETAILS,
	REVERSE_TRANSACTION,
	SHOW_ALERT
} from "../store/action-types";
import { mapGetters } from "vuex";
import _get from "lodash/get";

export default {
	name: "PassbookView",
	props: [
		"data",
		"headers",
		"loading",
		"model",
		"themeInputColor",
		"retailerDetails",
		"isRummyOptionSelected"
	],
	data() {
		return {
			END,
			TOP,
			showDialog: true,
			show: -1,
			dialog: false,
			startDate: new Date().toISOString().substr(0, 10),
			endDate: new Date().toISOString().substr(0, 10),
			startDateMenu: false,
			endDateMenu: false,
			showCommissionOnly: false,
			inProgressTxn: "",
			revertDialog: false
		};
	},
	directives: { infiniteScroll },
	methods: {
		loadMoreData(type) {
			this.$emit("LOAD_MORE_ROWS", {
				type,
				...(this.retailerDetails
					? { retailerId: this.retailerDetails.userId }
					: {}),
				...(this.showCommissionOnly ? { commission: true } : {})
			});
		},
		closeModal() {
			this.$emit("CLOSE_MODAL", this.model);
		},
		async downloadPassbook() {
			const payload = {
				access_token: this.ACCESS_TOKEN,
				params: {
					startDate: this.startDate,
					endDate: this.endDate
				}
			};
			const endpoint = `${BASE_URL}/jeet11-retail/v1.0.0/passbookReport`;
			const response = await ApiService.post(endpoint, payload);
			const { response: csv, errMsg, statusCode } = response;
			if (statusCode === 200) {
				const encodedUri = `data:text/csv;charset=utf-8,${encodeURI(
					csv
				)}`;
				if (window.ReactNativeWebView) {
					window.ReactNativeWebView.postMessage(
						JSON.stringify({
							csvData: {
								csv
							}
						})
					);
					return;
				}
				window.open(encodedUri);
			}
			if (errMsg) {
				this.showAlert(errMsg);
			}
			this.dialog = false;
		},
		showAlert(message) {
			this.$store.dispatch(SHOW_ALERT.dispatch, {
				text: message
			});
		},
		showUserHistory(userId) {
			this.$router.push({
				path: "user-history",
				query: { id: userId }
			});
		},
		_get,
		openRevertDialog(transactionId) {
			this.inProgressTxn = transactionId;
			this.revertDialog = true;
		},
		closeRevertDialog() {
			this.inProgressTxn = "";
			this.revertDialog = false;
		},
		fetchJeet11WalletDetails() {
			this.$store
				.dispatch(FETCH_JEET11_PARTNER_WALLET_DETAILS.dispatch, {
					isSchemeRequired: true
				})
				.catch(() => {})
				.then(() => {});
		},
		revertTransaction() {
			this.revertDialog = false;
			if (!this.inProgressTxn) return;
			this.$store
				.dispatch(REVERSE_TRANSACTION.dispatch, {
					transactionId: this.inProgressTxn,
					appType: this.isRummyOptionSelected ? "RUMMY" : "JEET11"
				})
				.catch(() => {})
				.then(() => {
					this.loadMoreData(TOP);
					this.fetchJeet11WalletDetails();
				})
				.finally(() => {
					this.inProgressTxn = "";
				});
		}
	},
	computed: {
		...mapState({
			ACCESS_TOKEN: state => state.auth.ACCESS_TOKEN,
			alert: state => state.common.alert
		}),
		isEndDateGreaterThanStartDate() {
			return (
				new Date(
					this.startDate
						.split("/")
						.reverse()
						.join("/")
				) <=
				new Date(
					this.endDate
						.split("/")
						.reverse()
						.join("/")
				)
			);
		},
		...mapGetters({
			isJeet11Distributor: "auth/isJeet11Distributor"
		})
	},
	watch: {
		showCommissionOnly() {
			this.loadMoreData(TOP);
		}
	}
};
</script>
<style scoped>
.header {
	color: #fff;
	font-size: 18px;
	line-height: 21px;
	text-align: center;
	letter-spacing: 0.004em;
	padding: 18px 0px;
	position: fixed;
	z-index: 1;
	width: 100%;
}
.card-item {
	background: #ffffff;
	box-shadow: 0px 2px 8px rgba(0, 49, 176, 0.05);
	border-radius: 12px;
	padding: 12px 16px;
	margin: 12px 4px;
}
.bg {
	padding: 4.5em 1em 1em 1em;
	border-radius: 12px;
}
.theme-text {
	color: #233b5d;
}
.expand-more {
	position: absolute;
	right: 0px;
	top: 24px;
}
.align-right {
	display: flex;
	justify-content: right;
	direction: rtl;
	overflow-wrap: anywhere;
}
</style>
